var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBlur03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 941,
    height: 787,
    viewBox: "0 0 941 787",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7_14622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.5,
    cy: 435.876,
    rx: 126.5,
    ry: 89.876,
    fill: "url(#paint0_linear_7_14622)",
    fillOpacity: 0.92
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7_14622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.5,
    cy: 403.5,
    rx: 300.5,
    ry: 213.5,
    fill: "url(#paint1_linear_7_14622)",
    fillOpacity: 0.53
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7_14622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.558 168.965C554.79 203.74 557.838 311.222 501.367 409.033C444.896 506.843 350.29 557.944 290.058 523.17C229.827 488.395 226.779 380.914 283.25 283.103C339.721 185.292 434.327 134.191 494.558 168.965Z",
    fill: "url(#paint2_linear_7_14622)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7_14622",
    x: 383,
    y: 226,
    width: 493,
    height: 419.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_7_14622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7_14622",
    x: 0,
    y: 20,
    width: 941,
    height: 767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 85,
    result: "effect1_foregroundBlur_7_14622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7_14622",
    x: 84.813,
    y: 0.0541992,
    width: 614.991,
    height: 692.027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79,
    result: "effect1_foregroundBlur_7_14622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_14622",
    x1: 603.276,
    y1: 388.476,
    x2: 678.038,
    y2: 539.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11D48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_14622",
    x1: 408.205,
    y1: 290.902,
    x2: 585.801,
    y2: 650.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11D48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_14622",
    x1: 286.526,
    y1: 382.712,
    x2: 580.666,
    y2: 422.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11A5D4",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlur03);
export default __webpack_public_path__ + "static/media/bg_blur-03.f85d581988490d97ad7d1f3714e4c0e0.svg";
export { ForwardRef as ReactComponent };